// extracted by mini-css-extract-plugin
export var center = "_4h-2";
export var clickableRow = "_4h-5";
export var expandedRow = "_4h-7";
export var hoverable = "_4h-4";
export var left = "_4h-1";
export var right = "_4h-3";
export var row = "_4h-0";
export var selectedRow = "_4h-6";
export var summaryRow = "_4h-8";